import { Component, OnInit } from '@angular/core';
import { Location } from '@angular/common';
import { User } from "../user/user";
import { Router } from '@angular/router';
import { UserService } from "../user/user.service";
import { trigger, state, style, animate, transition } from '@angular/animations';
import {Alert} from "../alert/alert";

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.css'],
  animations: [
    trigger('alertState', [
      state('hide', style({
        opacity: '0',
        display: 'none'
      })),
      state('show', style({
        opacity: '1',
        display: 'block'
      })),
      transition('hide => show, show => hide', animate('500ms ease-in'))
    ])
  ]
})
export class LoginComponent implements OnInit {

  constructor(public router:Router,
              private userService:UserService,
              public location:Location) {
  }

  ngOnInit() {
  }

  alert = new Alert("hide", "alert-danger", "Benutzername oder Passwort ist falsch");
  user = new User("", "");

  onSubmit() {
    // perform user login
    this.userService.login(this.user).subscribe(
      suc => this.location.back(),
      err => {
        this.alert.state = 'show';
        setTimeout(() => this.alert.state = 'hide', 4000);
      });
  }

}



// WEBPACK FOOTER //
// ./src/app/login/login.component.ts